import Image from "next/image";

const EngagementSectionTopContent = () => {
  return (
    <div className="grid grid-cols-12 gap-y-6 md:gap-x-4 lg:gap-x-8">
      <div className="col-span-12 md:col-span-5 lg:col-span-6 flex justify-center items-center">
        <div>
          <Image
            src="/images/haulers/engagement-01.png"
            alt="Market Details"
            width={560}
            height={444}
          />
        </div>
      </div>
      <div className="col-span-12 md:col-span-7 lg:col-span-6 flex flex-col justify-center items-center md:items-start space-y-6">
        <span className="mobile-h3 md:h4 lg:h3">Market Details</span>
        <span className="p-6 md:max-w-[480px] border border-1 border-white/50 bg-black/20 rounded-lg shadow-2xl backdrop-blur-xl">
          We provide our vendor partners a distinct market advantage through an
          extensive review of logistics, environment, landfills, and
          opportunities.
        </span>
      </div>
    </div>
  );
};

export default EngagementSectionTopContent;
